import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from '../../../shared/utils.service';
import { VERIFICATION_FILTER_OPTIONS } from '../users-verification-statuses';
import { AccountsSelectorComponent } from '../../accounts/accounts-selector/accounts-selector.component';

@Component({
  selector: 'app-users-filter',
  templateUrl: './users-filter.component.html',
  styleUrls: ['./users-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UsersFilterComponent implements OnInit {
  // Options come from the shared verification status definition so labels match the table and legend.
  readonly verificationOptions = VERIFICATION_FILTER_OPTIONS;

  // The current filter selection edited within this dialog.
  filter_options: {
    userType: string;
    verificationStatus: string;
    associatedAccounts: { id: number; name: string }[];
    employerAccounts: { id: number; name: string }[];
  } = {
    userType: '',
    verificationStatus: '',
    associatedAccounts: [],
    employerAccounts: []
  };

  constructor(
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<UsersFilterComponent>
  ) {
    // Ensure the incoming data has sensible defaults so the dialog never binds to undefined.
    if (typeof this.data['userType'] == 'undefined') {
      this.data['userType'] = '';
    }
    if (typeof this.data['verificationStatus'] == 'undefined') {
      this.data['verificationStatus'] = '';
    }
    if (!Array.isArray(this.data['associatedAccounts'])) {
      this.data['associatedAccounts'] = [];
    }
    if (!Array.isArray(this.data['employerAccounts'])) {
      this.data['employerAccounts'] = [];
    }
  }

  ngOnInit() {
    // Seed the dialog's working copy from the passed-in state.
    this.filter_options.userType = this.data['userType'];
    this.filter_options.verificationStatus = this.data['verificationStatus'];
    this.filter_options.associatedAccounts = this.data['associatedAccounts'];
    this.filter_options.employerAccounts = this.data['employerAccounts'];
  }

  /**
   * Open the accounts selector to choose which associated accounts to filter by.
   */
  onSelectAssociatedAccounts() {
    this.utils.showComponentDialog(
      AccountsSelectorComponent,
      {
        multiple: true,
        returnObjects: true,
        selected: this.filter_options.associatedAccounts
      },
      { width: '1200px' },
      (accounts: any[]) => {
        if (!accounts) {
          return;
        }
        this.filter_options.associatedAccounts = (accounts || []).map(
          (a: any) => ({ id: Number(a.id), name: a.name || '' })
        );
      }
    );
  }

  /**
   * Open the accounts selector to choose which employer accounts to filter by.
   */
  onSelectEmployerAccounts() {
    this.utils.showComponentDialog(
      AccountsSelectorComponent,
      {
        multiple: true,
        returnObjects: true,
        selected: this.filter_options.employerAccounts
      },
      { width: '1200px' },
      (accounts: any[]) => {
        if (!accounts) {
          return;
        }
        this.filter_options.employerAccounts = (accounts || []).map(
          (a: any) => ({ id: Number(a.id), name: a.name || '' })
        );
      }
    );
  }

  /**
   * Clear all filter options and send the cleared selection back.
   */
  onClearAndClose() {
    this.filter_options.userType = '';
    this.filter_options.verificationStatus = '';
    this.filter_options.associatedAccounts = [];
    this.filter_options.employerAccounts = [];
    this.onSaveAndClose();
  }

  /**
   * Close the dialog and send the selected filter options as the response.
   */
  onSaveAndClose() {
    this.dialogRef.close(this.filter_options);
  }
}
